import React from 'react';
import { MinimalUser } from '@components/basics/MinimalUser';
import { MediaQuery } from '@context/mediaQuery';
import type { FragmentType } from '@graphql/reactQuery';
import type { MinimalUserFragmentDoc } from '@graphql/reactQuery';

export const ListMinimalUser = ({
  userFrag,
  forceMobileView = false,
}: {
  userFrag: FragmentType<MinimalUserFragmentDoc>;
  forceMobileView?: boolean;
}) => {
  const { tabletLandscape, tablet } = MediaQuery.useContainer();

  return (
    <MinimalUser
      userFrag={userFrag}
      avatarSize={tablet && !forceMobileView ? 48 : 40}
      hideAvatar={!tabletLandscape || forceMobileView}
      verifiedSize={tablet ? 20 : 12}
      gap={tablet && !forceMobileView ? 8 : 4}
      borderRadius={1000}
      imagePriority={false}
    />
  );
};
